// src/components/ProductCard.js
import React from "react";
import "../styles/product.css";

function ProductCard({ id, title, price, rating, image, description, isForYou, onClick }) {
  return (
    <div className="product-card" onClick={onClick}>
      <img
        src={image}
        alt={title}
        className={isForYou ? "foryou-card__image" : "product-card__image"}
      />
      <div className="product-card__details">
        <h3 className="product-card__title">{title}</h3>
        <p className="product-card__price">AED {price}</p>
        <p className="product-card__rating">Rating: {rating}⭐</p>
        {description && <p className="product-card__description">{description}</p>}
      </div>
    </div>
  );
}

export default ProductCard;
